import React from 'react'
import { PageHeader, Space } from 'antd'
import styled from '@emotion/styled'

interface PageTooltipTypes {
  title?: string
  children: React.ReactChild | React.ReactChild[]
}

export const PageTooltip = (props: PageTooltipTypes) => (
  <Container>
    {props.title && (
      <PageHeader title={props.title} className='tooltip-title' />
    )}
    <Space className='tooltip-link' direction='vertical' align='start'>
      {props.children}
    </Space>
  </Container>
)

const Container = styled.div`
  background-color: #fafafb;
  padding: 16px 24px;
  border-radius: 8px;

  .tooltip-title.ant-page-header {
    padding: 0 0 16px 0;

    .ant-page-header-heading-title {
      color: #4a4a68;
      font-weight: 600;
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .tooltip-link > .ant-space-item {
    padding: 4px 0;
  }

  .tooltip-link > .ant-space-item > a {
    position: relative;

    margin-left: 16px;

    color: #d092dd;
    font-size: 14px;

    &::before {
      position: absolute;
      top: 50%;
      left: -16px;

      content: '';
      display: flex;
      width: 4px;
      height: 4px;
      background-color: #d092dd;
      border-radius: 50%;

      transform: translateY(-50%);
    }
  }

  .tooltip-link > .ant-space-item > a:hover {
    color: #4a4a68;

    &::before {
      background-color: #4a4a68;
    }
  }
`
